import { SupportedLanguage } from '@domain/models/shared.models';
import { StateToken } from '@ngxs/store';
import {
  CashRegisterStateModel,
  GlobalStateModel
} from '@shared/models/store.models';

// State Constants
export const GLOBAL_STATE_TOKEN = new StateToken<GlobalStateModel>(
  'webpay_cash_register_global'
);

export const CASH_REGISTER_STATE_TOKEN = new StateToken<CashRegisterStateModel>(
  'webpay_cash_register'
);

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {
    languageCode: 'FR',
    fullLanguageCode: 'fr-FR',
    flag: '/assets/icons/fr.svg'
  },
  {
    languageCode: 'EN',
    fullLanguageCode: 'en-EN',
    flag: '/assets/icons/gb.svg'
  }
];

export const DEFAULT_LANGUAGE: SupportedLanguage = {
  languageCode: 'FR',
  fullLanguageCode: 'fr-FR',
  flag: '/assets/icons/fr.svg'
};

export const DEFAULT_CASH_REGISTER_HOST_NAME = 'veone';
